class DesktopFixedBar extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.lastScroll = 0
    this.scrollDelay = 0
    this.hideBarTimeout = null
    this.gridBody = this.externalEls['grid-body'].element
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('scroll', this.handleScroll.bind(this), {
      passive: true,
    })
  }

  handleScroll () {
    const currentScroll = window.scrollY
    clearTimeout(this.hideBarTimeout)

    if (window.innerWidth < 768) {
      this.isHidden = false
      return
    }

    const originalBarRect = this.gridBody.getBoundingClientRect()
    const originalBarVisible = originalBarRect.top > 0

    if (!originalBarVisible) {
      if (currentScroll > this.lastScroll) {
        this.isHidden = true
      } else if (currentScroll < this.lastScroll) {
        this.hideBarTimeout = setTimeout(() => {
          this.isHidden = false
        }, this.scrollDelay)
      }
    } else {
      this.isHidden = false
    }

    this.lastScroll = currentScroll
  }

  get isHidden () {
    return this._isHidden
  }

  set isHidden (isHidden) {
    if (this._isHidden !== isHidden) {
      this._isHidden = isHidden
      this.setAttribute('aria-hidden', isHidden)
    }
  }
}

if (!customElements.get('desktop-fixed-bar')) {
  customElements.define('desktop-fixed-bar', DesktopFixedBar)
}
